import React, { lazy } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
// import 'bootstrap/dist/css/bootstrap.min.css';

import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import IpAddress from "./Components/Common/ipAddress/IpAddress";
import { MyContext } from "./Components/Common/ipAddress/MyContext";
import { UserProvider } from "./Components/Common/UserContext";
import { configureStore } from "./store";

const MyComponent = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={configureStore({})}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <MyContext.Provider value={<IpAddress />}>
          <UserProvider>
            <MyComponent />
            {/* <PDFViewer style={{ height: "100rem", width: "118rem" }}>
              <PDFDocument />
            </PDFViewer> */}
          </UserProvider>
        </MyContext.Provider>
      </BrowserRouter>
    </React.Fragment>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
